"use strict";

var _taggedTemplateLiteral = require("/app/react/marvin/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _chunkZELLDUQWjs = require('./chunk-ZELLDUQW.js');

var _chunkKV5PZLI6js = require('./chunk-KV5PZLI6.js');

var _chunkQRSJR5MPjs = require('./chunk-QRSJR5MP.js');

var _chunkD5ZGX3CTjs = require('./chunk-D5ZGX3CT.js');

var _chunkAKZK6LCVjs = require('./chunk-AKZK6LCV.js');

var _react = require('react');

var _styledcomponents = require('styled-components');

var _styledcomponents2 = _interopRequireDefault(_styledcomponents);

var y = _styledcomponents.css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    *,\n    ::before,\n    ::after {\n        box-sizing: border-box;\n    }\n"]))),
    v = _styledcomponents2.default.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    -webkit-text-size-adjust: 100%;\n    margin: 0;\n    -webkit-font-smoothing: antialiased;\n    -moz-osx-font-smoothing: grayscale;\n\n    ", ";\n"])), y),
    P = _styledcomponents.createGlobalStyle(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    html {\n        -webkit-font-smoothing : antialiased;\n        -moz-osx-font-smoothing: grayscale;\n    }\n    body {\n        margin: 0;\n    }\n    main {\n        display: block;\n    }\n    a {\n        background-color: transparent;\n    }\n    img {\n        border-style: none;\n    }\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n        font-family: inherit;\n        font-size: 100%;\n        line-height: 1.15;\n        margin: 0;\n    }\n    button,\n    input {\n        overflow: visible;\n    }\n    button,\n    select {\n        text-transform: none;\n    }\n    button,\n    [type=\"button\"],\n    [type=\"reset\"],\n    [type=\"submit\"] {\n        -webkit-appearance: button;\n    }\n    button::-moz-focus-inner,\n    [type=\"button\"]::-moz-focus-inner,\n    [type=\"reset\"]::-moz-focus-inner,\n    [type=\"submit\"]::-moz-focus-inner {\n        border-style: none;\n        padding: 0;\n    }\n    button:-moz-focusring,\n    [type=\"button\"]:-moz-focusring,\n    [type=\"reset\"]:-moz-focusring,\n    [type=\"submit\"]:-moz-focusring {\n        outline: 1px dotted ButtonText;\n    }\n    fieldset {\n        padding: 0.35em 0.75em 0.625em;\n    }\n    legend {\n        box-sizing: border-box;\n        color: inherit;\n        display: table;\n        max-width: 100%;\n        padding: 0;\n        white-space: normal;\n    }\n    progress {\n        vertical-align: baseline;\n    }\n    textarea {\n        overflow: auto;\n    }\n    [type=\"checkbox\"],\n    [type=\"radio\"] {\n        box-sizing: border-box;\n        padding: 0;\n    }\n    [type=\"number\"]::-webkit-inner-spin-button,\n    [type=\"number\"]::-webkit-outer-spin-button {\n        height: auto;\n    }\n    [type=\"search\"] {\n        -webkit-appearance: textfield;\n        outline-offset: -2px;\n    }\n    [type=\"search\"]::-webkit-search-decoration {\n        -webkit-appearance: none;\n    }\n    ::-webkit-file-upload-button {\n        -webkit-appearance: button;\n        font: inherit;\n    }\n    details {\n        display: block;\n    }\n    summary {\n        display: list-item;\n    }\n\n    ", ";\n"], ["\n    html {\n        -webkit-font-smoothing : antialiased;\n        -moz-osx-font-smoothing: grayscale;\n    }\n    body {\n        margin: 0;\n    }\n    main {\n        display: block;\n    }\n    a {\n        background-color: transparent;\n    }\n    img {\n        border-style: none;\n    }\n    button,\n    input,\n    optgroup,\n    select,\n    textarea {\n        font-family: inherit;\n        font-size: 100%;\n        line-height: 1.15;\n        margin: 0;\n    }\n    button,\n    input {\n        overflow: visible;\n    }\n    button,\n    select {\n        text-transform: none;\n    }\n    button,\n    [type=\\\"button\\\"],\n    [type=\\\"reset\\\"],\n    [type=\\\"submit\\\"] {\n        -webkit-appearance: button;\n    }\n    button::-moz-focus-inner,\n    [type=\\\"button\\\"]::-moz-focus-inner,\n    [type=\\\"reset\\\"]::-moz-focus-inner,\n    [type=\\\"submit\\\"]::-moz-focus-inner {\n        border-style: none;\n        padding: 0;\n    }\n    button:-moz-focusring,\n    [type=\\\"button\\\"]:-moz-focusring,\n    [type=\\\"reset\\\"]:-moz-focusring,\n    [type=\\\"submit\\\"]:-moz-focusring {\n        outline: 1px dotted ButtonText;\n    }\n    fieldset {\n        padding: 0.35em 0.75em 0.625em;\n    }\n    legend {\n        box-sizing: border-box;\n        color: inherit;\n        display: table;\n        max-width: 100%;\n        padding: 0;\n        white-space: normal;\n    }\n    progress {\n        vertical-align: baseline;\n    }\n    textarea {\n        overflow: auto;\n    }\n    [type=\\\"checkbox\\\"],\n    [type=\\\"radio\\\"] {\n        box-sizing: border-box;\n        padding: 0;\n    }\n    [type=\\\"number\\\"]::-webkit-inner-spin-button,\n    [type=\\\"number\\\"]::-webkit-outer-spin-button {\n        height: auto;\n    }\n    [type=\\\"search\\\"] {\n        -webkit-appearance: textfield;\n        outline-offset: -2px;\n    }\n    [type=\\\"search\\\"]::-webkit-search-decoration {\n        -webkit-appearance: none;\n    }\n    ::-webkit-file-upload-button {\n        -webkit-appearance: button;\n        font: inherit;\n    }\n    details {\n        display: block;\n    }\n    summary {\n        display: list-item;\n    }\n\n    ", ";\n"])), y);

var _jsxruntime = require('react/jsx-runtime');

var x = _react.createContext.call(void 0, function () {
  throw new Error("No onLinkClick found. Did you forget to add onLinkClick to HammerUIProvider (or the separate LinkProvider)?");
}),
    w = exports.a = function (_ref) {
  var e = _ref.children,
      r = _ref.onLinkClick;
  return _jsxruntime.jsx.call(void 0, x.Provider, {
    value: r,
    children: e
  });
},
    W = exports.b = function () {
  return _react.useContext.call(void 0, x);
},
    eo = exports.c = function () {
  var e = W();
  return _react.useCallback.call(void 0, function (r) {
    return function (i) {
      i.preventDefault(), e(r);
    };
  }, [e]);
};

var z = function z(_ref2) {
  var e = _ref2.children,
      r = _ref2.closeModalOnBackdropClick;

  var i = _chunkQRSJR5MPjs.a.call(void 0),
      a = _react.useCallback.call(void 0, function (l) {
    if (!r) return;
    var n = document.querySelector(".hammer-modal-container");
    n && (n.contains(l.target) || i());
  }, [i, r]);

  return _react.useEffect.call(void 0, function () {
    return _chunkKV5PZLI6js.a.call(void 0, window, "mouseup", a);
  }, [a]), _jsxruntime.jsx.call(void 0, q, {
    className: "hammer-modal-backdrop",
    children: e
  });
},
    q = _styledcomponents2.default.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    position: fixed;\n    z-index: 1000;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: ", ";\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    ", ";\n\n    &.hammer-modal-backdrop {\n        animation-name: ", ";\n    }\n\n    &.hammer-modal-backdrop-reverse {\n        animation-name: ", ";\n    }\n"])), function (_ref3) {
  var e = _ref3.theme;
  return e.core.transparent40;
}, _chunkZELLDUQWjs.e, _chunkZELLDUQWjs.b, _chunkZELLDUQWjs.d);

var _jotai = require('jotai');

var C = function C() {
  var e = _jotai.useAtomValue.call(void 0, _chunkD5ZGX3CTjs.f);

  return e !== null ? _jsxruntime.jsx.call(void 0, z, {
    closeModalOnBackdropClick: e[2],
    children: e[0]
  }) : null;
};

var To = function To(_ref4) {
  var e = _ref4.children,
      r = _ref4.defaultHeight,
      i = _ref4.defaultWidth,
      a = _ref4.forceGridHighlight,
      _ref4$normalizationTy = _ref4.normalizationType,
      l = _ref4$normalizationTy === void 0 ? "global" : _ref4$normalizationTy,
      n = _ref4.onLinkClick,
      L = _ref4.theme,
      N = _ref4.windowSizeThrottle,
      T = _ref4.withoutHighlighter,
      S = _ref4.withoutJotaiProvider,
      H = _ref4.withoutModalTarget,
      s = _ref4.withoutNormalization,
      M = _ref4.withoutThemeProvider,
      E = _ref4.withoutWindowSizeProvider;
  var o = e;
  return process.env.NODE_ENV !== "test" && (o = _jsxruntime.jsx.call(void 0, _react.StrictMode, {
    children: e
  })), !s && l === "scoped" && (o = _jsxruntime.jsx.call(void 0, v, {
    children: e
  })), T || (o = _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
    children: [_jsxruntime.jsx.call(void 0, _chunkAKZK6LCVjs.t, {
      forceGridHighlight: a
    }), o]
  })), E || (o = _jsxruntime.jsx.call(void 0, _chunkAKZK6LCVjs.m, {
    defaultHeight: r,
    defaultWidth: i,
    windowSizeThrottle: N,
    children: o
  })), !s && l === "global" && (o = _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
    children: [_jsxruntime.jsx.call(void 0, P, {}), o]
  })), H || (o = _jsxruntime.jsxs.call(void 0, _jsxruntime.Fragment, {
    children: [_jsxruntime.jsx.call(void 0, C, {}), o]
  })), S || (o = _jsxruntime.jsx.call(void 0, _jotai.Provider, {
    children: o
  })), M || (o = _jsxruntime.jsx.call(void 0, _styledcomponents.ThemeProvider, {
    theme: L,
    children: o
  })), n && (o = _jsxruntime.jsx.call(void 0, w, {
    onLinkClick: n,
    children: o
  })), _jsxruntime.jsx.call(void 0, _jsxruntime.Fragment, {
    children: o
  });
};

exports.a = w;
exports.b = W;
exports.c = eo;
exports.d = C;
exports.e = To;